import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=f379aebe&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f379aebe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f379aebe')) {
      api.createRecord('f379aebe', component.options)
    } else {
      api.reload('f379aebe', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=f379aebe&scoped=true&", function () {
      api.rerender('f379aebe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2d0yVuWTcoKnt/JS/comp/Accordion.vue"
export default component.exports